// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-wrapper[data-v-c6bdc170] {
  max-width: 300px;
}
.logo[data-v-c6bdc170] {
  max-height: 200px;
  max-width: 100%;
  object-fit: contain;
  object-position: left;
}
.center-content[data-v-c6bdc170] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
